import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Banner from "../components/Header";
import "../css/ClientForm.css";
import { savePendiente } from "../services/solicitudes";
import { useGlobalLoadingEffect } from "../components/GlobalLoadingProvider";
import { SOLICITUD_ESTADOS, SOLICITUD_TIPO } from "../config/solicitud";

const formatFechaSolicitud = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const MIN_MESES_ANTIGUEDAD = 6;

const TELEFONO_EJEMPLO = "1142681704";

function ClientForm() {
  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");
  const [email, setEmail] = useState("");
  const [telefono, setTelefono] = useState("");
  const [ingresoMensual, setIngresoMensual] = useState("");
  const [fechaIngreso, setFechaIngreso] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  useGlobalLoadingEffect(isSubmitting);

  const location = useLocation();
  const navigate = useNavigate();
  const { cuil, monto, cuotas } = location.state || {};

  const handleTelefonoChange = (event) => {
    const digitsOnly = event.target.value.replace(/\D/g, "");
    setTelefono(digitsOnly);
  };

  const handleAntiguedadChange = (event) => {
    const startDate = new Date(event.target.value);
    const today = new Date();
    const monthsDiff = Math.floor(
      (today.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24 * 30)
    );

    if (Number.isFinite(monthsDiff) && monthsDiff < MIN_MESES_ANTIGUEDAD) {
      alert("Debes tener una antigÃ¼edad laboral mÃ­nima de 6 meses para enviar el formulario.");
      event.target.value = "";
      return;
    }

    setFechaIngreso(event.target.value);
  };

  const resetForm = () => {
    setNombre("");
    setApellido("");
    setEmail("");
    setTelefono("");
    setIngresoMensual("");
    setFechaIngreso("");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (isSubmitting) {
      return;
    }

    if (
      !nombre ||
      !apellido ||
      !email ||
      !cuil ||
      !telefono ||
      !monto ||
      !cuotas ||
      !ingresoMensual ||
      !fechaIngreso
    ) {
      alert("Por favor completÃ¡ todos los campos requeridos.");
      return;
    }

    const today = new Date();
    const startDate = new Date(fechaIngreso);
    const monthsDiff = Math.floor(
      (today.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24 * 30)
    );

    if (!Number.isFinite(monthsDiff) || monthsDiff < MIN_MESES_ANTIGUEDAD) {
      alert("Debes tener una antigÃ¼edad laboral mÃ­nima de 6 meses para enviar el formulario.");
      return;
    }

    const telefonoNormalizado = telefono.replace(/\D/g, "");

    if (telefonoNormalizado.length < 10) {
      alert(`El telÃ©fono debe tener 10 dÃ­gitos. Faltan nÃºmeros. Ejemplo: ${TELEFONO_EJEMPLO}.`);
      return;
    }

    if (telefonoNormalizado.length > 10) {
      alert(`El telÃ©fono no debe superar los 10 dÃ­gitos. Cargalo sin 0 ni 15, por ejemplo: ${TELEFONO_EJEMPLO}.`);
      return;
    }

    const emailNormalizado = String(email || "").trim().toLowerCase();
    if (!/^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$/.test(emailNormalizado)) {
      alert("IngresÃ¡ un email vÃ¡lido.");
      return;
    }

    setIsSubmitting(true);
    setShowSpinner(true);

    try {
      const cuilNormalizado = String(cuil || "").replace(/\D/g, "");
      await savePendiente({
        nombre,
        apellido,
        email: emailNormalizado,
        cuil: cuilNormalizado,
        monto,
        cuotas,
        telefono: telefonoNormalizado,
        ingresoMensual,
        fechaIngreso,
        fechaSolicitud: formatFechaSolicitud(today),
        estado: SOLICITUD_ESTADOS.PENDIENTE,
        tipoPrestamo: SOLICITUD_TIPO.PERSONAL,
        resultadoEvaluacionCodigo: null,
        resultadoEvaluacionDescripcion: null,
      });

      resetForm();

      alert("Datos registrados exitosamente!");
      navigate("/");
    } catch (error) {
      console.error("Error submitting data:", error);
      alert(
        error?.code === "blocked_contact"
          ? "No pudimos procesar la solicitud con los datos ingresados."
          : "OcurriÃ³ un error al guardar la solicitud. IntentÃ¡ nuevamente."
      );
    } finally {
      setIsSubmitting(false);
      setShowSpinner(false);
    }
  };

  return (
    <div className="main">
      <div className="banner__container">
        <Banner />
      </div>
      <h1 className="firsth1">Solicitá tu crédito</h1>
      <form onSubmit={handleSubmit}>
        <div className="form__container">
          <div className="form__container__leftpanel">
            <h3 className="user__data">
              <label>
                CUIL:
                <span>{cuil}</span>
              </label>
            </h3>

            <h3 className="user__data">
              <label>
                MONTO:
                <span>{monto}</span>
              </label>
            </h3>

            <h3 className="user__data">
              <label>
                CUOTAS:
                <span>{cuotas}</span>
              </label>
            </h3>

            <label>
              Nombre:
              <input
                type="text"
                value={nombre}
                onChange={(event) => setNombre(event.target.value)}
              />
            </label>

            <label>
              Apellido:
              <input
                type="text"
                value={apellido}
                onChange={(event) => setApellido(event.target.value)}
              />
            </label>
            <label>
              Email:
              <input
                type="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                placeholder="correo@ejemplo.com"
              />
            </label>
          </div>
          <div className="form__container__rightpanel">
            <label>
              TelÃ©fono:
              <input
                type="tel"
                value={telefono}
                onChange={handleTelefonoChange}
                placeholder="1123456789"
              />
            </label>

            <label>
              Ingreso mensual:
              <input
                type="number"
                value={ingresoMensual}
                onChange={(event) => setIngresoMensual(event.target.value)}
              />
            </label>

            <label>
              Fecha de ingreso a su actual empleo (AntigÃ¼edad):
              <input
                type="date"
                value={fechaIngreso}
                onChange={handleAntiguedadChange}
              />
            </label>
          </div>
        </div>
        <button className="form__btn" type="submit" disabled={isSubmitting}>
          {showSpinner ? (
            <span className="spinner">Enviando...</span>
          ) : (
            "Enviar"
          )}
        </button>
        <div className="statement__text">
          <p>
            Una vez que su solicitud de crédito sea aprobada por nuestro equipo de evaluación, un representante
            comercial de Microcuotas se comunicará¡ con usted para solicitar cualquier documentación adicional necesaria.
            La transferencia del dinero se realizará¡ previa firma del solicitante en la sucursal de Microcuotas, donde se
            le entregará¡ la carpeta de crédito con todos los detalles de su préstamo.
          </p>
        </div>
      </form>
    </div>
  );
}

export default ClientForm;
